import CybsButton from '@cybs-ui/components/lib/button';
import { useEffect, useState } from 'react';
import './heroImageComponent.scss';
import { useDispatch, useSelector } from 'react-redux';
import bannerImage from '../../assets/HeroImage.png';
import {
  setDefaultBanner,
  setMicroformOnlyBanner,
  switchButton
} from '../../redux/action/3ds-actions';

function HeroImageComponent() {
  const bannerValues = useSelector((state) => state.runSeqReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(setDefaultBanner());
  }, [bannerValues]);
  const [button1State, setButton1State] = useState('primary');
  const [button2State, setButton2State] = useState('secondary');
  const [selectedButton, setSelectedButton] = useState('button1');
  const handleClick = (buttonClicked) => {
    if (buttonClicked === 'button1') {
      setButton1State('primary');
      setButton2State('secondary');
      setSelectedButton('button1');
      dispatch(setDefaultBanner());
      dispatch(switchButton('button1'));
    } else if (buttonClicked === 'button2') {
      setButton1State('secondary');
      setButton2State('primary');
      setSelectedButton('button2');
      dispatch(setMicroformOnlyBanner());
      dispatch(switchButton('button2'));
    }
  };

  return (
    <div className="banner">
      <img src={bannerImage} alt="bannerImage" className="banner_image" />
      <div className="row w-100 bannerMain">
        <div className="row position-relative py-3">
          <div className="col-lg-1" />
          <div className="col-lg-5 bannerMain-titleBox">
            <div className="row py-2">
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-12 p5 heroImage-title__main">
                    <p>{bannerValues.bannerTitle}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 p5 heroImage-title__secondary">
                    <p>{bannerValues.bannerSubtitle}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row py-2">
              <div className="col-lg-12">
                <CybsButton
                  style={{ fontSize: '12px' }}
                  className="button button1"
                  colorScheme={button1State}
                  i18n={{ label: 'Microform with Payer Authentication Demo' }}
                  onClick={() => handleClick('button1')}
                  dataTest="microform-with-payer-auth"
                  iconClass={selectedButton === 'button1' ? 'checkmark' : ''}
                >
                  <span className="material-icon" />
                </CybsButton>
                <CybsButton
                  style={{ fontSize: '12px' }}
                  colorScheme={button2State}
                  i18n={{ label: 'Microform Only Demo' }}
                  onClick={() => handleClick('button2')}
                  dataTest="microform-only"
                  iconClass={selectedButton === 'button2' ? 'checkmark' : ''}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroImageComponent;
